import React from "react"
import Image from "next/image"

import { mobileImageContainer } from "./MobileImage.css"

type Props = {
  imageSrc?: string
  title: string
  modulePosition: number
}

export const MobileImage: React.FC<Props> = ({
  imageSrc,
  title,
  modulePosition,
}) => (
  <div className={mobileImageContainer}>
    <Image
      src={imageSrc || "/images/placeholders/800x800.svg"}
      alt={title}
      title={title}
      priority={modulePosition < 3}
      width={800}
      height={800}
      sizes="100vw"
    />
  </div>
)
